import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Subscription } from "rxjs";
import { getApp } from "../app";
import { SearchWords } from "../filter/filter.service.type";
import { FieldTypes } from "../../../../shared/settings/settings";

@Component({
    selector: "app-filter-header-table",
    templateUrl: "./filter-header-table.component.html",
    styleUrls: ["./filter-header-table.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterHeaderTableComponent implements OnInit {
  @Input() column = "";
  @Input() docType = "";
  fieldId = "";
  fieldType = "";
  model: SearchWords = {};

  app = getApp((app) => {
    this.app = app;
  });

  private _resetFilterSubscription: Subscription = new Subscription();
  private _sectionSubscription: Subscription = new Subscription();

  async ngOnInit() {
    this.fieldId = this.app.filterHeaderTable.getFieldId(
      this.docType,
      this.column
    );
    this.fieldType = this.setFieldType();

    this._resetFilterSubscription =
      this.app.filterHeaderTable.resetAllFilters.subscribe((value) => {
        if (value) {
          this.model[this.fieldId] = "";
          this.app.filterHeaderTable.resetHeaderFilters();
        }
      });

    this._sectionSubscription = this.app.RMSubmenu.sectionSubject.subscribe(
      async () => {
        if (this.app.filterHeaderTable.isFilterSelected) {
          this.app.paginator.resetPagination();
        }
      }
    );
  }

  setFieldType() {
    // Make the fields of type typeahead

    this.app.field.changeFieldSettings(this.fieldId, FieldTypes.typeahead);

    // Date columns keep the date picker. changeFieldSettings only acts on the fields it knows,
    // so the ones it would otherwise turn into a typeahead are named back here; the rest keep
    // their declared "timestamp" type and getFieldType maps that to the picker as well.
    this.dateColumns().forEach((fieldId) =>
      this.app.field.changeFieldSettings(fieldId, FieldTypes.dateInterval)
    );

    return this.app.filterHeaderTable.getFieldType(this.fieldId);
  }

  private dateColumns() {
    return [
      this.app.fieldId.manufacturer.lastUpdatedOn,
      this.app.fieldId.manufacturer.to,
      this.app.fieldId.manufacturer.from,
      this.app.fieldId.manufacturer.estimatedEOLDate,
      this.app.fieldId.manufacturer.expirationDate
    ];
  }

  openDatePicker(fieldId: string, event: MouseEvent) {
    event.stopPropagation();
    this.app.datesFilter.field = fieldId;
    this.app.datesFilter.showComponent = true;
  }

  clearDateFilter(fieldId: string) {
    if (this.app.datesFilter.model.dateMode === "interval") {
      this.app.filterHeaderTable.clearDateRangeFilter(fieldId);
    } else {
      this.app.filterHeaderTable.clearFilter(fieldId);
      this.model[fieldId] = "";
    }
    this.app.datesFilter.clear();
  }

  checkKey(event: KeyboardEvent, field: any, model: any) {
    if (event.key === "Enter") {
      this.app.filterHeaderTable.filter(field, model);
    }
    if (event.key === "Backspace") {
      if (model != null && model.length === 1) {
        this.app.filterHeaderTable.clearFilter(field);
      }
    }
  }

  clearFilter(fieldId: string) {
    this.app.filterHeaderTable.clearFilter(fieldId);
    this.model[fieldId] = "";
  }

  searchTypeahead(fieldId: string) {
    const value = this.app.typeAheadBasic.model[fieldId];
    this.app.model[fieldId] = value;
    this.app.filterHeaderTable.filter(fieldId, value);
  }

  closeDropdown() {
    document.body.click();
  }

  ngOnDestroy(): void {
    if (this._resetFilterSubscription) {
      this._resetFilterSubscription.unsubscribe();
    }
    if (this._sectionSubscription) {
      this._sectionSubscription.unsubscribe();
    }
    this.app.field.resetFieldType(this.fieldId);
  }
}
